import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-057ae64e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = ["onClick"];
import { toRef, ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    src: {
      type: String,
      require: true
    },
    list: {
      type: Array,
      require: true
    }
  },
  emits: ['play'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const audio = new Audio();
    const data = toRef(props, 'list');
    const currentId = ref(-1);
    data.value.map(item => {
      item.isPlay = false;
      return item;
    });
    const play = async item => {
      emit('play', item);
      return;
      if (currentId.value != item.id) {
        audio.src = item.songUrl;
        plays(item);
      } else {
        if (audio.paused) {
          plays(item);
        } else {
          audio.pause();
          pause();
        }
      }
      console.log(currentId.value != item.id);
    };
    const pause = () => {
      data.value.map(_r => {
        _r.isPlay = false;
        return _r;
      });
    };
    const plays = item => {
      audio.play().then(res => {
        pause();
        currentId.value = item.id;
        item.isPlay = true;
      });
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.src,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["main-list", {
            'active': item.isPlay
          }]),
          key: index,
          onClick: $event => play(item)
        }, [_createTextVNode(_toDisplayString(item.songname) + " ", 1), _createVNode(_component_van_icon, {
          name: item.isPlay ? 'pause-circle-o' : 'play-circle-o',
          size: "28"
        }, null, 8, ["name"])], 10, _hoisted_5);
      }), 128))])])]);
    };
  }
});